import React, { useState, useEffect } from 'react';
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
  ProgressBar,
} from 'react-bootstrap';
import AppSpinner from '../Extras/AppSpinner/AppSpinner';
import { connect } from 'react-redux';
import { apiUrl } from '../../utils/consts';
import { couponBenefits } from '../../utils/couponCategories';
import PsePayment from '../PsePayment/PsePayment';
import CardPayment from '../CardPayment/CardPayment';
import { getTotalAmount, getTotalAmountInfo } from '../../utils/amounts';
import { formatMoney } from '../../utils/formatMoney';
import { setUpdateUserInfo } from '../../redux/modules/auth';
import DescuentoNomina from '../DescuentoNomina/DescuentoNomina';
import './styles/couponBenefit.scss';

const select = (state) => {
  return {
    userId: state.auth.userId,
    token: state.auth.token,
    user: state.auth.user,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setUpdateUserInfo: (payload) => dispatch(setUpdateUserInfo(payload)),
  };
}

const benefitAmountValues = [
  { value: '20000', label: '20.000', amount: 20000 },
  { value: '50000', label: '50.000', amount: 50000 },
  { value: '100000', label: '100.000', amount: 100000 },
  { value: '200000', label: '200.000', amount: 200000 },
];

function ConnectedCouponBenefitComponent(props) {
  const { match } = props;
  const { id } = match.params;

  const [loading, setLoading] = useState(true);
  const [benefitApplication, setBenefitApplication] = useState();
  const [selectedBenefitAmount, setSelectedBenefitAmount] =
    useState('20000');
  const [otherAmount, setOtherAmount] = useState('');
  const [paymentType, setPaymentType] = useState('PSE');
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentStage, setPaymentStage] = useState(false);

  let category;
  let benefit;

  if (benefitApplication) {
    category = benefitApplication.category;
    benefit = couponBenefits.find((item) => item.id === category);
  }

  const fetchData = async () => {
    setLoading(true);

    if(id === "65b183cc37ab694c04139c24"){
      //redirect to crowdfunding
      window.location.href = "https://cemex.nibi.com.co/seccion_solidaria?tab=1&id=65bbaf94f8471c451c6546da";
    }

    const applicationResp = await fetch(`${apiUrl}/benefitApplications/get/${id}`);
    const applicationJson = await applicationResp.json();

    if (applicationJson.success)
      setBenefitApplication(applicationJson.application);

    setLoading(false);
  };

  useEffect(() => {
    if (props.userId) fetchData();
  }, [id]);

  const handleClosePaymentModal = () => {
    setShowPaymentModal(false);
    setOtherAmount('');
    setPaymentType('PSE');
    setPaymentStage(false);
    setSelectedBenefitAmount('20000');
  };

  const handlePayment = () => {
    setShowPaymentModal(true);
  };

  const handlePaymentStep = () => {
    if (selectedBenefitAmount === 'OTRO') {
      if (!otherAmount) return alert('Ingresa un valor.');
    }

    setPaymentStage(true);
  };

  if (loading || !props.token) {
    return (
      <div className='coupon-benefit-component'>
        <Container>
          <AppSpinner />
        </Container>
      </div>
    );
  }

  if (!benefit) return <div></div>;

  const amountInfo = getTotalAmountInfo(
    parseInt(
      selectedBenefitAmount !== 'OTRO'
        ? selectedBenefitAmount
        : otherAmount
    ),
    paymentType
  );

  return (
    <div className='coupon-benefit-component'>
      <Container>
        <Row>
          <Col lg={6}>
            <div className='selectedSlideContainer'>
              <img
                className='selectedSlideImage'
                src={benefit.thumbnail}
              />
            </div>
          </Col>
          <Col lg={6}>
            <h1>Bono para {benefit.category}</h1>
            {benefitApplication.userName && (
              <p className='user-name'>
                Solicitada por: {benefitApplication.userName}
              </p>
            )}
            <p className='benefit-description'>
              {benefitApplication.details}
            </p>
            {benefitApplication.benefitAmount > 0 && (
              <div className='benefit-progress-bar'>
                <div className='progress-label'>
                  {`${
                    !benefitApplication.amountRaised
                      ? 0
                      : formatMoney(
                          Math.floor(benefitApplication.amountRaised)
                        )
                  } de ${formatMoney(benefitApplication.benefitAmount)}`}
                </div>
                <ProgressBar
                  now={
                    !benefitApplication.amountRaised
                      ? 0
                      : (benefitApplication.amountRaised /
                          benefitApplication.benefitAmount) *
                        100
                  }
                />
              </div>
            )}
            <div className='coupon-benefit-options'>
              <Button
                className='benefit-add-to-cart'
                onClick={handlePayment}>
                Quiero aportar
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      <Modal
        show={showPaymentModal}
        onHide={handleClosePaymentModal}
        size='lg'>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className='coupon-modal-content'>
          {paymentStage ? (
            <Col xs={12}>
              <i
                className='fas fa-arrow-alt-circle-left back-icon'
                onClick={() => setPaymentStage(false)}
              />
              {paymentType === 'PSE' ? (
                <PsePayment
                  amount={
                    selectedBenefitAmount !== 'OTRO'
                      ? getTotalAmount(
                          parseInt(selectedBenefitAmount),
                          'PSE'
                        )
                      : getTotalAmount(parseInt(otherAmount), 'PSE')
                  }
                  paymentType={'BENEFIT_PAYMENT'}
                  benefitCategory={benefit.id}
                  benefitApplicationId={id}
                />
              ) : paymentType === 'CARD' ? (
                <CardPayment
                  amount={
                    selectedBenefitAmount !== 'OTRO'
                      ? getTotalAmount(
                          parseInt(selectedBenefitAmount),
                          'CARD'
                        )
                      : getTotalAmount(parseInt(otherAmount), 'CARD')
                  }
                  paymentType={'BENEFIT_PAYMENT'}
                  benefitCategory={benefit.id}
                  benefitApplicationId={id}
                />
              ) : (
                <DescuentoNomina
                  amount={
                    selectedBenefitAmount !== 'OTRO'
                      ? getTotalAmount(
                          parseInt(selectedBenefitAmount),
                          'DESCUENTO_NOMINA'
                        )
                      : getTotalAmount(
                          parseInt(otherAmount),
                          'DESCUENTO_NOMINA'
                        )
                  }
                  paymentType={'BENEFIT_PAYMENT'}
                  benefitCategory={benefit.id}
                  benefitApplicationId={id}
                />
              )}
            </Col>
          ) : (
            <Form.Row>
              <Col xs={12}>
                <Alert variant='info'>
                  A continuación te mostramos los valores asociados a este
                  pago. Ten en cuenta que el <strong>monto final</strong> a
                  pagar depende del método de pago que selecciones:
                  <ul>
                    <li>
                      <strong>
                        {paymentType === 'PSE'
                          ? 'PSE:'
                          : paymentType === 'CARD'
                          ? 'Tarjeta de crédito:'
                          : 'Descuento de nómina:'}
                      </strong>
                      <ul>
                        <li>
                          Valor del bono:{' '}
                          {formatMoney(
                            selectedBenefitAmount !== 'OTRO'
                              ? selectedBenefitAmount
                              : otherAmount
                          )}
                        </li>
                        <li>
                          Costos financieros y de tecnología:{' '}
                          {formatMoney(amountInfo.totalDiscounted)}
                        </li>
                        <li>TOTAL: {formatMoney(amountInfo.total)}</li>
                      </ul>
                    </li>
                  </ul>
                </Alert>
              </Col>
              <Form.Group
                as={Col}
                md={6}>
                <Form.Label className='app-label'>
                  Valor del bono
                </Form.Label>
                <Form.Control
                  as='select'
                  value={selectedBenefitAmount}
                  onChange={(event) =>
                    setSelectedBenefitAmount(event.target.value)
                  }>
                  {
                    benefitAmountValues.map((item) => (
                      <option
                        key={item.value}
                        value={item.value}>
                        {item.label}
                      </option>
                    ))
                  }
                  <option value='OTRO'>Otro</option>
                </Form.Control>
              </Form.Group>
              {selectedBenefitAmount === 'OTRO' && (
                <Form.Group
                  as={Col}
                  md={6}>
                  <Form.Label className='app-label'>Valor</Form.Label>
                  <Form.Control
                    type='number'
                    placeholder='Valor'
                    value={otherAmount}
                    onChange={(event) =>
                      setOtherAmount(event.target.value)
                    }
                    required
                  />
                </Form.Group>
              )}
              <Form.Group
                as={Col}
                md={6}>
                <Form.Label className='app-label'>
                  Método de pago
                </Form.Label>
                <Form.Control
                  as='select'
                  value={paymentType}
                  onChange={(event) => setPaymentType(event.target.value)}>
                  <option value='PSE'>PSE</option>
                  <option value='CARD'>Tarjeta de crédito</option>
                  <option value='DESCUENTO_NOMINA'>
                    Descuento de nómina
                  </option>
                </Form.Control>
              </Form.Group>
              <Col xs={12}>
                <Button
                  className='app-button'
                  onClick={handlePaymentStep}>
                  Continuar
                </Button>
              </Col>
            </Form.Row>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

const CouponBenefitComponent = connect(
  select,
  mapDispatchToProps
)(ConnectedCouponBenefitComponent);

export default CouponBenefitComponent;
